export default __webpack_public_path__ + "6ceeb9999d501e8ed26440c82f885d9e.png";